import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { AssignService } from '@app/dir_group_assignor/assign/assign.service';
import { GameService } from '@app/dir_group_assignor/games/game.service';
import { DeviceService } from '@services/device.service';
import { MainService } from '@services/main.service';
import { MeService } from '@services/me.service';
import { GlobasConst } from '@shared/constants/global-const';
import { HeadTitleComponent } from "../../../../shared/components/head-title/head-title.component";
import { BtnComponent } from "../../../../shared/components/btn/btn.component";
import { SvgComponent } from "../../../../shared/components/__svg_img/svg/svg.component";
import { CurrencyCentsPipe } from '@app/dir_group_assignor/payments/pipes/currency-cents.pipe';
import { ConverTransfersStatusToVisualText, GameTransfersDetailsDto } from '@app/dir_group_assignor/payments/components/payments-assignor-fees/game-transfers-details-dto';
import { StatusComponent } from '@components/status/status.component';

@Component({
  selector: 'app-transaction-info',
  standalone: true,
  imports: [CommonModule, CurrencyCentsPipe, HeadTitleComponent, BtnComponent, SvgComponent, StatusComponent],
  templateUrl: './transaction-info.component.html',
  styleUrls: ['./transaction-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TransactionInfoComponent implements OnInit {
  ConverTransfersStatus = ConverTransfersStatusToVisualText;
  getTimeStringAsDate(timeString: string | undefined | null): Date | null {
    if (timeString == null)
      return null;
    const today = new Date();
    const [hours, minutes, seconds] = timeString.split(':').map(Number);
    today.setHours(hours, minutes, seconds);
    return today;
  }
  cameFromTransactions = false;

  gameData?: GameTransfersDetailsDto;
  constructor(

    public globalConst: GlobasConst,
    private mainService: MainService,
    public meS: MeService,
    public gameS: GameService,
    private route: ActivatedRoute,
    public router: Router,
    public deviceS: DeviceService,
    public assignS: AssignService,
    public cd: ChangeDetectorRef) {
    var t = meS.me;
  }

  ngOnInit(): void {
    const transactionId = this.route.snapshot.queryParams['gameId'];
    const transferData = history.state?.transferData;
    if(transactionId) {
      this.mainService.getPaymentDetails(transactionId).subscribe((x: GameTransfersDetailsDto) => {
        this.gameData = {
          ...x,
          overallTransfersStatus: transferData?.displayOperationStatus ||  transferData?.displayTransactionType ,
          transactionDate: transferData?.transferCreatedAt || x.transactionDate,
          totalInCents: transferData.transferTotal?.amount,
          description: transferData?.description || x.description,
          role: transferData?.officialPositionName,
          gameType: transferData?.gameType,
          assignorName: transferData?.assignorName,
        };
        this.cd.markForCheck();
      });
    } else if (transferData) {
      this.gameData = {
        description: transferData?.description ,
        totalInCents: transferData.transferTotal?.amount,
        notchPayFeeInCents: transferData.payoutFee?.amount,
        payoutDestination: transferData.description?.[1],
        overallTransfersStatus: transferData.displayOperationStatus,
        transactionDate: transferData.transferCreatedAt,
        estimatedArrival: transferData.expectedPayoutArrivalDate,
        lastUpdated: transferData.transferLastUpdatedAt,
      } as any;
      this.cd.markForCheck();
    }
    const state = history.state;
    this.cameFromTransactions = state?.cameFromTransactions === true;

  }

  goBack() {
  if (this.cameFromTransactions) {
    this.router.navigate(['/myWalletOfficial/all'], { queryParams: {} }); 
  } else {
    this.router.navigate(['/myWalletOfficial']);
  }
  }
  

  isNotPaidOrIntransit(): boolean {
    if (!this.gameData?.gameId && !this.gameData?.gameNumber) {
      return false;
    }

    const status = this.gameData?.overallTransfersStatus;
    return status !== 'PAID' && status !== 'IN_TRANSIT';
  }

}


